import type { CommandProperties } from '@atlassian/rovo-content-bridge-api';
import { CommandHandler, type PassThroughCommandProps } from '@atlassian/editor-rovo-bridge';

import { log } from '../utils/aifc-logging.ts';
import type { ExtraCommandProps } from '../RovoBridgeCommandListener.tsx';

export class PrepareContentForFinalizationCommandHandler extends CommandHandler<
	CommandProperties,
	{ success: boolean }
> {
	constructor(
		props: PassThroughCommandProps,
		private extraProps: Pick<ExtraCommandProps, 'forceDraftSync'>,
	) {
		super(props);
	}

	execute(): Promise<{ success: boolean }> {
		log('handle prepare-content-for-finalization-command');
		return new Promise<{ success: boolean; content: any }>(async (resolve) => {
			try {
				const document = await this.extraProps.forceDraftSync?.();
				resolve({ success: true, content: document });
			} catch {
				resolve({ success: false, content: undefined });
			}
		});
	}
}
